import {
  $parse,
  CustomParseFieldProps,
  PointerEdit,
} from "@opendash/plugin-parse";
import { Button } from "antd";
import React from "react";
type ParseOrderArticleFieldProps = CustomParseFieldProps<any>;
const ParseOrderArticleField = ({
  parseObject,
  value,
  fieldname,
  setValue,
}: ParseOrderArticleFieldProps) => {
  if (setValue) {
    return (
      <PointerEdit
        value={parseObject.get("article")}
        setValue={setValue}
        targetClass="OD3_MES_Article"
        isRequired={true}
        isNullable={false}
      ></PointerEdit>
    );
  }

  return (
    <Button
      type="default"
      onClick={() => {
        $parse.ui.openObject(parseObject.get("article"));
      }}
    >
      {parseObject.get("article").get("artnr") +
        " - " +
        parseObject.get("article").get("name")}
    </Button>
  );
};

export default ParseOrderArticleField;
export type { ParseOrderArticleFieldProps };
